import { Fragment } from "react"
import Summary from "./Summary"

function Dashboard() {
  return (
    <Fragment>
      <Summary />
    </Fragment>
  )
}

export default Dashboard